import React, { memo, useEffect } from "react"

import { wowPartnerApi } from "@shared/apis"
import { Search, SendBox, Tab, ToolBox } from "@shared/components"
import CheckButton from "@shared/components/chat/CheckButton"
import {
  MessagesProvider,
  useAccount,
  useChatInfo,
  useSchedule,
} from "@shared/contexts"
import { getParam } from "@shared/modules"
import { usePartnerStore } from "@shared/stores/partnerStore"

import ManagerMessages from "./ManagerMessages"
import TradeItemList from "./tradeItem/TradeItemList"
import UserMessages from "./UserMessages"

function Chatting() {
  const { isSearchBarEnabled, chatMenu } = useChatInfo()
  const { schedule } = useSchedule()

  const isUserGroup = chatMenu === "USER"
  const isManagerGroup = chatMenu === "MANAGER"
  const isTraderGroup = chatMenu === "TRADER"
  const isPaidSchedule = schedule?.paymentInformation === "PAID"
  const isFreeSchedule = schedule?.paymentInformation === "FREE"
  const isAllSchedule = schedule?.paymentInformation === "ALL"
  const isChatEnabled = schedule?.isChatEnabled || false
  const { account } = useAccount()
  const isPaidAndPaidUser =
    isPaidSchedule && account.viewer?.role === "PAID_USER"
  const { setPartnerStockList } = usePartnerStore()
  const streamerUsername = schedule?.user.username
  const joinDate = getParam("joinDate")

  let showSendBox =
    isChatEnabled && (isUserGroup || (isManagerGroup && isPaidSchedule))

  // 방송상태체크 버튼 노출: 채팅창이 없고, (공개+유저 | 공개가 아닌 방송+매니저)
  const showCheckButton =
    !showSendBox &&
    ((isAllSchedule && isUserGroup) || (!isAllSchedule && isManagerGroup))

  // 채팅 컬럼(USER/MANAGER 탭)에서 입력창·방송체크 둘 다 없을 때 채우는 빈 슬롯
  // (예: 공개방송 파트너메시지 탭). 매매전략(TRADER) 탭은 채팅 컬럼이 아니므로 제외.
  const showBottomSpacer =
    !showSendBox && !showCheckButton && chatMenu !== "TRADER"

  const getPartnerStockApi = () => {
    if (!streamerUsername || !isPaidAndPaidUser) return

    if (!joinDate || joinDate.length === 0) return

    wowPartnerApi.getPartnerStock(streamerUsername, joinDate).then((result) => {
      setPartnerStockList(result.data)
    })
  }

  useEffect(() => {
    getPartnerStockApi()
  }, [streamerUsername, joinDate])

  return (
    <MessagesProvider limitCount={100}>
      <Tab key="tab" isUser={true} />
      {chatMenu !== "TRADER" && (
        <>
          <ToolBox key="toolBox" isChatMode={false} />
          {isSearchBarEnabled && <Search key="search" isChatMode={false} />}
        </>
      )}

      {isTraderGroup && isPaidAndPaidUser && (
        <TradeItemList
          isActive={isTraderGroup}
          handleRefresh={() => {
            getPartnerStockApi()
          }}
        />
      )}
      <>
        {/* 유저 메시지 노출 조건
          - 채팅이 가능한 스케줄이거나 (or)
          - 공개방송  */}
        {(isChatEnabled || isAllSchedule || isFreeSchedule) && (
          <UserMessages isActive={isUserGroup} />
        )}
        {/* 매니저 메시지 노출조건
          - 채팅이 가능한 스케줄이면서 공개/무료 방송이거나 (and)
          - 채팅이 불가능한 스케줄이여야함 (or)
          - Tab.tsx의 파트너메시지 탭 노출 규칙과 일치시켜야 함
         */}
        {((isChatEnabled && (isAllSchedule || isFreeSchedule)) ||
          !isChatEnabled) && <ManagerMessages isActive={isManagerGroup} />}
        {showSendBox ? (
          <SendBox />
        ) : showCheckButton ? (
          <CheckButton />
        ) : showBottomSpacer ? (
          <div className="chatBottomSlot" aria-hidden />
        ) : null}
      </>
    </MessagesProvider>
  )
}

export default memo(Chatting)
